import { backendApi } from "@api/base/backend";

export async function createRole(name: string) {
  const data = await backendApi.callApi(
    "/admin/roles",
    "POST",
    JSON.stringify({ name }),
  );

  return { data };
}

export async function addRolePermission(
  name: string,
  permissions: string[],
) {
  const data = await backendApi.callApi(
    `/admin/roles/${name}/permission`,
    "POST",
    JSON.stringify({ permissions }),
  );

  return { data };
}

